import * as api from '@/api';

export default {
    data() {
        return {
            client: {
                name: '',
                firstName: '',
                lastName: '',
                email: null,
                phone: '',
                address: '',
                city: '',
                state: '',
                zip: '',
            },

            submitPending: false,
            submitError: null,
        };
    },

    methods: {
        async createClient() {
            if (!this.$refs.clientForm.validate()) {
                return;
            }

            this.submitPending = true;
            this.submitError = null;

            const company = this.$store.state.company.id;
            const res = await api.createClient({ ...this.client, company });

            this.submitPending = false;

            if (res.error) {
                this.submitError = res.error.message;
                this.$awn.alert('Failed to create client');
                return null;
            }

            this.submitError = null;
            this.$awn.success('New client added');

            this.$store.dispatch('company/fetchOverview');

            return res.body;
        },
    },
};
